import { siteConfig } from '@/mocks/siteConfig';

const stats = [
  { value: siteConfig.stats.totalVideos, label: '视频资源', icon: 'ri-video-line' },
  { value: siteConfig.stats.categories + '个', label: '内容分类', icon: 'ri-folder-line' },
  { value: siteConfig.stats.dailyVisitors, label: '日均访问', icon: 'ri-user-line' },
  { value: siteConfig.stats.articlesPublished, label: '精选文章', icon: 'ri-article-line' },
];

export default function StatsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 text-accent-500">
                <i className={`${stat.icon} text-2xl`}></i>
              </div>
              <p className="text-2xl md:text-3xl font-heading text-foreground-900 mb-1">
                {stat.value}
              </p>
              <p className="text-xs text-secondary-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}